<template>
	<div class="hero">
		<div class="wrap">
			<router-link :to="{name: 'home'}">
				<div class="logo" v-html="icon('hero')"></div>
			</router-link>

			<h2 class="sub">
				Device mockup generator for your screenshots
			</h2>

			<!-- <div class="search">
				<input placeholder="Search for device" v-model="search">
			</div> -->
			<icons></icons>

			<div class="line"></div>
		</div>

		<top></top>

		<div class="hero-bottom"></div>
	</div>
</template>

<script>
import icons from "./hero/icons.vue";
import top from "./hero/top.vue";

export default {
	components: {icons, top},
	computed: {
		desc() {
			return this.$store.state.desc;
		},
		search: {
			get() {
				return this.$store.state.search;
			},
			set(string) {
				this.$store.state.search = string;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.hero {
	position: relative;

	&-bottom {
		position: absolute;
		bottom: 0;
	}

	h1,
	h2 {
		color: $topColor;
	}

	.wrap {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		flex-direction: column;
		z-index: 1;
		text-align: center;
		background-color: $topBack;
		padding: 0 1em;
		padding-top: 2.4em;
		padding-bottom: 0.5em;
		background-image: $topPattern;

		@include res {
			padding-top: 1.8em;
		}

		@include mobile {
			padding-top: 1.6em;
		}
	}
}

$cobalt: #006aff;

$dimmy: #0cc5ba;
$face: $black1;

.logo {
	::v-deep {
		svg {
			width: 15em;
			height: 100%;
			// filter: drop-shadow(2px 2px 0 white)
			// drop-shadow(-2px 2px 0 white)
			// drop-shadow(2px -2px 0 white)
			// 	drop-shadow(-2px -2px 0 white);

			#dimmy {
				path {
					fill: $dimmy;
				}
				#Stroke-17,
				#Stroke-19 {
					fill: none;
					stroke: $dimmy;
				}
				#face {
					path {
						fill: $face;
						stroke: $face;
					}
				}
			}

			#phone {
				rect {
					stroke: $topBack;
				}
			}
		}
	}
}

.sub {
	font-size: 1em;
	line-height: 1.4em;
	margin-top: 1em;
	font-style: italic;
	text-align: center;

	@include res {
		margin-top: 0.5em;
	}
}
.search {
	max-width: 100%;

	@include res {
		margin-top: 1em;
		font-size: 0.9em;
	}

	input {
		outline: none;
		appearance: none;
		font-size: 0.9em;
		border: 1px solid $topColor;
		border-radius: 6px;
		padding: 0.7em;
		max-width: 100%;
		width: 28em;
		background-color: $topBack;
		color: $topColor;
		box-shadow: inset 0 1px 3px rgba(10, 10, 10, 0.1);

		@include placeholder {
			color: transparentize($topColor, 0.2);
		}

		@include res {
			width: 24em;
		}
	}
}

.line {
	display: none;
	width: 10em;
	background-color: $color1-light;
	height: 2px;
	border-radius: 8px;
	margin: 1em 0;
}
</style>
